import { BusinessObjectBase } from './../../../bo';
import { CollectionChangingAction, ObservableCollection } from './../../../observable';
import { JoinPointContext, JoinPoint } from './../../../aop';
import { ModelBase } from './../../../model';

export class CollectionChangedJoinPoint extends JoinPoint<CollectionChangedJoinPointContext> { }

export class CollectionChangedJoinPointContext extends JoinPointContext {
    public constructor(
        sender: BusinessObjectBase<ModelBase>,
        public readonly collection: ObservableCollection<ModelBase>,
        public readonly action: CollectionChangingAction,
        public readonly newItems: Object[],
        public readonly oldItems: Object[]
    ) {
        super(sender);
    }
}
